var chunkMapping = {
	"315": [
		4679
	],
	"329": [
		4378,
		7893,
		5876,
		7056,
		6749,
		197,
		6863,
		5695,
		748,
		6443,
		3487,
		4434,
		7428
	],
	"689": [
		6897
	]
};
var idToExternalAndNameMapping = {
	"197": [
		"default",
		"./query",
		332
	],
	"748": [
		"default",
		"./feature-flag",
		332
	],
	"3487": [
		"default",
		"./AddToQuote",
		8599
	],
	"4378": [
		"default",
		"./auth",
		332
	],
	"4434": [
		"default",
		"./widget",
		8599
	],
	"4679": [
		"default",
		"./state",
		332
	],
	"5695": [
		"default",
		"./QuickInsights",
		8599
	],
	"5876": [
		"default",
		"./dialog",
		332
	],
	"6443": [
		"default",
		"./adobe",
		332
	],
	"6749": [
		"default",
		"./provider",
		332
	],
	"6863": [
		"default",
		"./InsightsMessagingQueue",
		8599
	],
	"6897": [
		"default",
		"./AdServeBanner",
		8599
	],
	"7056": [
		"default",
		"./logout",
		332
	],
	"7428": [
		"default",
		"./routing",
		332
	],
	"7893": [
		"default",
		"./config",
		332
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_modules__[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_modules__[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}